import { yyyy, zzzz } from "../../store.svelte";
const uri: string = yyyy.uri.api;

export default async () => {
	if (!yyyy.sesh.logtoken) {
		return false;
	}

	let _hdrs = {
		"Content-Type": "application/json",
		Authorization: "Bearer " + yyyy.sesh.logtoken.token,
	};
	let _body = JSON.stringify({
		lw_name: yyyy.sesh.activeLivewire.wireident,
	});
	let fetchopts = { method: "POST", headers: _hdrs, body: _body };
	const response = await fetch(`${uri}/rpc/mvtjson`, fetchopts);
	if (response.ok) {
		let data = await response.json();
		return data;
		//console.log(mapdata);
	} else {
		alert("There was an error");
	}
};


